module.exports = __webpack_public_path__ + "static/img/logo.c4510497.png";